import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import ButtonComponent from "../../../../app/common-components/ButtonComponent";
import CustomModal from "../../../../app/common-components/CustomModal";
import DrillDownOffCanvas from "../../../../app/common-components/DrillDown/DrillDownOffCanvas.jsx";
import Spinners from "../../../../app/common-components/Spinner.jsx";
import CompleteTableData from '../../../../app/common-components/Table/CompleteTableData.jsx';
import { setIsOffCanvasOpen } from "../../../../app/commonSlice";
import { getSortingValues } from "../../../../app/Constants.js";
import { configurationApi } from "../../../../app/services/configurationApi";
import { useCommonAlert } from "../../../../app/utilities/helpers.js";
import { user } from "../../../../assets/images";
import { setErrorAlert, setUserManagement, userManagementListAPI } from "../../configurationSlice.js";
import './styles.scss';
import UserManagemetDrillDown from "./UserManagemetDrillDown";

const UserManagement = () => {
  const [state, setState] = useState({
    page: 0,
    limit: 10,
    tableData: [],
    count: 0,
    onboardTool: [],
    deleteUserId: "",
    deleteUseremail: "",
    modalOpen: false,
    currentPageAPI: 0,
    isStatusUpdating: false,
    isUserDeleting: false,
    headerSortingState: {
      accessor: "",
      isDataSorted: "",
    },
  });
  const dispatch = useDispatch();
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  const [pageLimit, setPageLimit] = useState(10);
  const [searchKey, setSearchInputValue] = useState("");
  const [pageNo, setPageNo] = useState(0);

  const {
    userManagementLoadPage,
    userManagementListCount,
    userManagementListCountLoading,
    userManagementListData,
    userManagementListDataLoading,
    error
  } = useSelector((state) => state.configuration);

  const calculatedPageCount = userManagementListData.totalCount ? Math.ceil(userManagementListData.totalCount / pageLimit) : 0;
  const finalPageCount = calculatedPageCount !== 0 ? calculatedPageCount : 1;

  const { userName, userRole } = useSelector((state) => state.common.loggedUser);
  const notAllowedRoles = ["Department Head", "Division Head"];
  const userAccess = !userRole.some(role => notAllowedRoles.includes(role));
  const [deleteUserLoading, setdeleteUserLoading] = useState(false);
  const [changeUserStatus] = configurationApi.useChangeUserStatusMutation();
  const [deleteUser] = configurationApi.useDeleteUserMutation();

  useEffect(() => {
    if (error == true) {
      callCommonAlert("error", "Something went wrong. Please try again.");
      hideCommonAlert();
      dispatch(setErrorAlert());
    }
  }, [error]);

  const getPayload = (key, sortByColumn = state.headerSortingState.accessor, sortingOrder = state.headerSortingState.isDataSorted) => {
    return {
      keyword: key ? key : '',
      sortByColumn: sortByColumn,
      sortingOrder: sortingOrder,
    };
  };
  const handleOnSorting = (column) => {
    const { sortingField, isDataSorted } = getSortingValues(
      columns,
      column,
      state.headerSortingState
    );

    setState(prev => ({
      ...prev,
      sortByColumn: sortingField,
      sortingOrder: isDataSorted,
      headerSortingState: {
        accessor: sortingField,
        isDataSorted: isDataSorted,
      }
    }));

    const payload = getPayload(state.searchKey, sortingField, isDataSorted);
    fetchData({
      payload, pageNo: state.page, pageLimit: pageLimit,
    });
  };

  const fetchData = (payload) => {
    dispatch(userManagementListAPI({ payload: payload.payload, pageNo: payload.pageNo, pageLimit: payload.pageLimit }));
  };


  const columns = [
    {
      Header: "User",
      accessor: "userId",
      Cell: ({ row }) => {
        const imageUrl = row?.original.imageUrl;
        const userImage = imageUrl
          ? `data:image/jpeg;base64,${imageUrl}`
          : user; // fallback image
        const hasImage = !!imageUrl;

        const renderTooltip = (props) => (
          <Tooltip id="user-tooltip" {...props} className="bg-white">
            <div className="d-flex flex-column align-items-center bg-white">
              <img
                src={userImage}
                alt="User Preview"
                className="popup-image mb-1"
                style={{ width: "80px", height: "80px", objectFit: "cover" }}
              />
              <div>{row?.original?.userId || "Unknown User"}</div>
            </div>
          </Tooltip>
        );

        return (
          <div className="d-flex align-items-center">
            {hasImage ? (
              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
              >
                <div className="image-wrapper position-relative">
                  <img
                    src={userImage}
                    alt="User Profile"
                    className="profile-image me-1"
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                    }}
                  />
                </div>
              </OverlayTrigger>
            ) : (
              <img
                src={userImage}
                alt="User Profile"
                className="profile-image me-1"
                style={{ width: "30px", height: "30px", borderRadius: "50%" }}
              />
            )}
            {row?.original?.userId ? row?.original?.userId : "-"}
          </div>
        );
      },
    },
    {
      Header: "Full Name",
      accessor: "fullName",
    },
    {
      Header: "Email ID",
      accessor: "email",
    },
    {
      Header: "Role",
      accessor: "role",
      Cell: ({ value }) => {
        const formattedRoles = Array.isArray(value)
          ? value?.map((role, index) => (
            <div key={role}>
              {role}
              {index < value.length - 1 && ","}
            </div>
          ))
          : "-";

        return <>{formattedRoles}</>;
      },
    },
    {
      Header: "Status",
      accessor: "Status",
      thClassName: "text-center",
      disableSortBy: true,
      className: "text-center",
      Cell: ({ row }) => {
        return (
          <label className="toggle-control">
            <input
              type="checkbox"
              className="switchInput"
              id="switchInput"
              checked={row.original.status == "ENABLE"}
              onChange={(e) => {
                ChangeUserStatus(
                  row.original.id,
                  e.target.checked,
                  row.original.userId,
                  row.original.email
                );
              }}
            />
            <span className="control" data-testid="toggleInput"></span>
          </label>
        );
      },
    },

    {
      Header: "Actions",
      thClassName: "text-center",
      accessor: "action",
      disableSortBy: true,
      tdclassname: "text-center",

      Cell: ({ row }) => (
        <td className="d-flex justify-content-around fs-5">
          <FiEdit
            title="Edit"
            className="iconStyleActions"
            data-testid="editIcon"
            onClick={() => onEditData(row)}
          />
          <FiTrash2
            title="Delete"
            data-testid={"deleteIcon"}
            className="iconStyleActions"
            onClick={() => onDeleteData(row)}
          />
        </td>
      ),
    },
  ];
  const ChangeUserStatus = (id, checked, userID, email) => {
    const tableData = state.tableData.map((user) => {
      if (user.id === id) {
        return {
          ...user,
          status: checked,
        };
      }
      return user;
    });
    const status = checked === true ? "ENABLE" : "DISABLE";
    setState({
      ...state,
      isStatusUpdating: true,
    });
    const payload = {
      "userId": userID,
      "email": email,
      "status": status
    };
    changeUserStatus({ payload, userName })
      .then((data) => {
        const statusCode = data.data.statusCodeValue;
        const message = data.data.body;

        if (statusCode === 200) {
          callCommonAlert("success", message);
          hideCommonAlert();
          setState({
            ...state,
            tableData,
            isStatusUpdating: false,
          });
          const payload = getPayload(searchKey);
          fetchData({ payload, pageNo: pageNo, pageLimit: pageLimit });
        } else if (statusCode === 400 || statusCode === 404) {
          callCommonAlert("error", message);
          hideCommonAlert();
          setState({
            ...state,
            isStatusUpdating: false,
          });
        } else {
          callCommonAlert("error", "Something went wrong. Please try again.");
          hideCommonAlert();
          setState({
            ...state,
            isStatusUpdating: false,
          });
        }
      })
      .catch(() => {
        callCommonAlert("error", "Something went wrong. Please try again.");
        hideCommonAlert();
      });
  };

  const recallAPI = () => {
    const payload = getPayload(searchKey);
    setPageNo(0);
    fetchData({ payload, pageNo: 0, pageLimit: pageLimit });
  };

  const openDrillDown = () => {
    dispatch(
      setIsOffCanvasOpen({
        isDrilldownOpen: true,
        title: "Add User",
        selectedData: {
          customDrillDownCanvas() {
            return <UserManagemetDrillDown recallAPI={recallAPI} />;
          },
        },
      })
    );
  };

  const onEditData = (row) => {
    if (userAccess) {
      dispatch(
        setIsOffCanvasOpen({
          isDrilldownOpen: true,
          title: "Update User",
          selectedData: {
            customDrillDownCanvas() {
              return <UserManagemetDrillDown ids={row.original.ids} recallAPI={recallAPI} />;
            },
          },
        })
      );
    }
  };
  const onDeleteData = async (row) => {
    if (userAccess) {
      // const { data } = await getOnboardedTools(row.original.ids);
      setState((state) => ({
        ...state,
        modalOpen: true,
        deleteUserId: row.original.userId,
        deleteUseremail: row.original.email,
        // onboardTool: data,
      }));
    }
  };

  const deleteConformUser = () => {
    setState((state) => ({
      ...state,
      isUserDeleting: true,
    }));
    const payload = {
      "userId": state.deleteUserId,
      "email": state.deleteUseremail,
    };
    deleteUser({ payload })
      .unwrap(setdeleteUserLoading(true))
      .then((data) => {
        setdeleteUserLoading(false);
        setState((state) => ({
          ...state,
          modalOpen: false,
        }));
        if ((userManagementListData?.totalCount - 1) % 10 === 0) {
          setPageNo(pageNo - 1);
        }
        const payload = getPayload(searchKey);
        fetchData({ payload, pageNo: pageNo, pageLimit: pageLimit });
        if (data.statusCodeValue === 200) {
          callCommonAlert("success", data?.body);
          hideCommonAlert();
          setState((state) => ({
            ...state,
            isUserDeleting: false,
          }));
        } else if (data.statusCodeValue === 400) {
          callCommonAlert("error", data?.body);
          hideCommonAlert();
          setState((state) => ({
            ...state,
            isUserDeleting: false,
          }));
        } else {
          callCommonAlert("error", "Something went wrong. Please try again.");
          hideCommonAlert();
        }
        dispatch(setUserManagement(!userManagementLoadPage));
      })
      .catch(() => {
        callCommonAlert("error", "Something went wrong. Please try again.");
        hideCommonAlert();
        setState((state) => ({
          ...state,
          isUserDeleting: false,
        }));
      });
  };
  const modalBody = () => (
    <>
      <h4>Delete User</h4>
      {deleteUserLoading ? <Spinners /> : (<div>
        <p>
          Are you sure you would like to remove the user?
        </p>
        <div className="btnswrap mt-0">
          <ButtonComponent
            text="Cancel"
            className={"cancelBtnStyle btn btn-primary"}
            data-testid="cancel-delete-user-btn"
            onClick={handleClose}
          />

          <ButtonComponent
            text="Delete"
            className={"btnStyle btn btn-primary"}
            data-testid="confirm-delete-user-btn" 
            onClick={deleteConformUser}
          />
        </div>
      </div>)}
    </>
  );

  useEffect(() => {
    setSearchInputValue('');
    const payload = getPayload();
    dispatch(userManagementListAPI({ payload: payload, pageNo: pageNo, pageLimit: pageLimit }));
  }, []);

  const handleClose = () => {
    setState((state) => ({
      ...state,
      modalOpen: false,
    }));
  };

  const handlePageLimitChange = (newPageLimit) => {
    setPageLimit(newPageLimit);
    setPageNo(0);
    const payload = getPayload(searchKey);
    fetchData({ payload, pageNo: 0, pageLimit: newPageLimit });
  };

  const handlePageNoChange = (pageNumber) => {
    setPageNo(pageNumber);
    const payload = getPayload(searchKey);
    fetchData({ payload, pageNo: pageNumber, pageLimit: pageLimit });
  };

  const onSearch = (e) => {
    setPageNo(0);
    setSearchInputValue(e);
    const payload = getPayload(e);
    fetchData({ payload, pageNo: 0, pageLimit: pageLimit });
  };

  const btnData = [
    {
      text: "Add",
      className: !userAccess ? "solid-btn accessDisabled" : "solid-btn",
      function: openDrillDown,
      disabled: !userAccess
    }
  ];

  return (
    <>
      <DrillDownOffCanvas
        customClass={"flowblock toolwrap custom_scroll"}
        subHeading={"Please enter your User data."}
        currentDrilldown={'UserManagement'}
      />
      <CustomModal
        modalBody={modalBody}
        modalOpen={state.modalOpen}
        modalHide={handleClose}
        closeBtn={true}
        closeBtnFuc={handleClose}
        modalTitle={"Delete User"}
      />
      <div className="grid-table config_cover mt-2">
        <CompleteTableData
          isLoading={userManagementListDataLoading || state.isStatusUpdating || state.isUserDeleting}
          data={userManagementListData?.data || []}
          columns={columns}
          pageNo={pageNo}
          pageLimit={pageLimit}
          onPageLimitChange={handlePageLimitChange}
          listCount={userManagementListData?.totalCount}
          onPageNoChange={handlePageNoChange}
          curentPageNumber={pageNo}
          totalPageCount={finalPageCount}
          onSearch={onSearch}
          searchKey={searchKey}
          btnData={btnData}
          moveSearchToEnd={true}
          onSorting={handleOnSorting}
          headerSortingState={state.headerSortingState}
          enableSorting={true}
        />
        {/* )} */}
      </div>
    </>
  );
};
export default UserManagement;

UserManagement.propTypes = {
  row: PropTypes.object.isRequired,
  value: PropTypes.array.isRequired,
};